import { render, staticRenderFns } from "./dg-title.vue?vue&type=template&id=9b19478a&scoped=true"
import script from "./dg-title.vue?vue&type=script&lang=js"
export * from "./dg-title.vue?vue&type=script&lang=js"
import style0 from "./dg-title.vue?vue&type=style&index=0&id=9b19478a&prod&lang=less&scoped=true"
import style1 from "./dg-title.vue?vue&type=style&index=1&id=9b19478a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b19478a",
  null
  
)

export default component.exports